import { render, staticRenderFns } from "./SalesRoom.vue?vue&type=template&id=35091b44&scoped=true&"
import script from "./SalesRoom.vue?vue&type=script&lang=js&"
export * from "./SalesRoom.vue?vue&type=script&lang=js&"
import style0 from "./SalesRoom.vue?vue&type=style&index=0&id=35091b44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35091b44",
  null
  
)

export default component.exports